import { useEffect, useState } from 'react';
import MagTekCardReader from '../devices/card-reader/MagTekCardReader';
import MagtekCardReaderCardData from '../devices/card-reader/MagtekCardReaderCardData';
import logger from '../helpers/logger';

export function useMagTekCardReader() {
	const [data, setData] = useState<MagtekCardReaderCardData | null>(null);

	useEffect(() => {
		const magTekHelper = new MagTekCardReader(setData);

		// Cleanup on unmount
		return () => {
			magTekHelper?.Clean();
		};
	}, []);

	useEffect(() => {
		if (data) logger.logCardReader.log({}, `Credit card swiped: ...${data?.lastFourDigits}`);
	}, [data]);

	return data;
}
